<div class="grade-class-container" [class.rtl]="currLang == 'ar'">
    <div *ngIf="fullGrades.length > 0 " class="control-bar">
        <app-control-bar [listType]="'grades'"></app-control-bar>
    </div>
    <div *ngIf="loading" class="loading">
        <mat-spinner mode="indeterminate"></mat-spinner>
    </div>

    <div *ngIf="fullGrades.length > 0 && !loading" class="list-container">
        <div class="cards-pane" *ngIf="rowsView == 'list'">
            <div class="grade-class-list">
                <app-grade-class-card *ngFor="let grade of grades ; index as i" [grade]="grade"
                    [gradeIndex]="i"></app-grade-class-card>
            </div>

            <!-- every grade at a glance , one click away from its card -->
            <aside class="grades-index">
                <div class="index-head">
                    <span class="index-title">{{'grades-classes.errors' | translate}}</span>
                </div>
                <div class="index-counts">
                    <span class="index-stat">
                        <span class="stat-label">{{'grades-classes.grades' | translate}}</span>
                        <span class="stat-value">{{gradesCount | arabicNumber: currLang}}</span>
                    </span>
                    <span class="stat-divider"></span>
                    <span class="index-stat">
                        <span class="stat-label">{{'grades-classes.classes' | translate}}</span>
                        <span class="stat-value">{{classesCount | arabicNumber: currLang}}</span>
                    </span>
                </div>
                <div class="index-list">
                    <button type="button" class="index-item" *ngFor="let item of gradesIndex"
                        [class.critical]="item.critical" [class.warning]="item.warning"
                        [class.active]="item.id === activeGradeId" (click)="jumpToGrade(item.id)">
                        <!-- nothing missing -->
                        <svg *ngIf="!item.critical && !item.warning" width="17" height="17" viewBox="0 0 24 24"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="1.5" />
                            <path d="M8.25 12.25L10.75 14.75L15.75 9.25" stroke="currentColor" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <!-- a supervisor is missing , dismissal still runs -->
                        <svg *ngIf="item.warning" width="17" height="17" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="1.5" />
                            <path d="M12 7.5V12.75M12 16.25H12.01" stroke="currentColor" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <!-- gate / teacher / flow missing , this grade cannot dismiss -->
                        <svg *ngIf="item.critical" width="17" height="17" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
                                stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12 9V13M12 16.5H12.01" stroke="currentColor" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span class="index-name">{{item.name}}</span>
                    </button>
                </div>
            </aside>
        </div>
        <div class="grade-class-list" *ngIf="rowsView == 'compact'">
            <!-- <app-table-view [controls]="tableControls" [sortingIndexRow]="saveSortFlag" (eventHandeler)="tableEventHandeler($event)"></app-table-view> -->
            <table cdkDropListGroup>
                <thead>
                    <tr>
                        <th [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
                            <svg *ngIf="showSortIcon" style="cursor: pointer;" class="sorting-index" (click)="toggleSortingIndex()" width="25" height="28" viewBox="0 0 36 28"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M17.4999 4.66671H3.49992C3.1905 4.66671 2.89375 4.54379 2.67496 4.325C2.45617 4.10621 2.33325 3.80946 2.33325 3.50004C2.33325 3.19062 2.45617 2.89388 2.67496 2.67508C2.89375 2.45629 3.1905 2.33337 3.49992 2.33337H17.4999C17.8093 2.33337 18.1061 2.45629 18.3249 2.67508C18.5437 2.89388 18.6666 3.19062 18.6666 3.50004C18.6666 3.80946 18.5437 4.10621 18.3249 4.325C18.1061 4.54379 17.8093 4.66671 17.4999 4.66671Z"
                                fill="#707070" />
                            <path
                                d="M15.1666 11.6667H3.49992C3.1905 11.6667 2.89375 11.5438 2.67496 11.325C2.45617 11.1062 2.33325 10.8095 2.33325 10.5C2.33325 10.1906 2.45617 9.89388 2.67496 9.67508C2.89375 9.45629 3.1905 9.33337 3.49992 9.33337H15.1666C15.476 9.33337 15.7728 9.45629 15.9915 9.67508C16.2103 9.89388 16.3333 10.1906 16.3333 10.5C16.3333 10.8095 16.2103 11.1062 15.9915 11.325C15.7728 11.5438 15.476 11.6667 15.1666 11.6667Z"
                                fill="#707070" />
                            <path
                                d="M12.8333 18.6667H3.49992C3.1905 18.6667 2.89375 18.5438 2.67496 18.325C2.45617 18.1062 2.33325 17.8095 2.33325 17.5C2.33325 17.1906 2.45617 16.8939 2.67496 16.6751C2.89375 16.4563 3.1905 16.3334 3.49992 16.3334H12.8333C13.1427 16.3334 13.4394 16.4563 13.6582 16.6751C13.877 16.8939 13.9999 17.1906 13.9999 17.5C13.9999 17.8095 13.877 18.1062 13.6582 18.325C13.4394 18.5438 13.1427 18.6667 12.8333 18.6667Z"
                                fill="#707070" />
                            <path
                                d="M10.4999 25.6667H3.49992C3.1905 25.6667 2.89375 25.5438 2.67496 25.325C2.45617 25.1062 2.33325 24.8095 2.33325 24.5C2.33325 24.1906 2.45617 23.8939 2.67496 23.6751C2.89375 23.4563 3.1905 23.3334 3.49992 23.3334H10.4999C10.8093 23.3334 11.1061 23.4563 11.3249 23.6751C11.5437 23.8939 11.6666 24.1906 11.6666 24.5C11.6666 24.8095 11.5437 25.1062 11.3249 25.325C11.1061 25.5438 10.8093 25.6667 10.4999 25.6667Z"
                                fill="#707070" />
                            <path
                                d="M20.9999 23.3334C20.6905 23.3334 20.3938 23.2105 20.175 22.9917C19.9562 22.7729 19.8333 22.4761 19.8333 22.1667V3.50004C19.8333 3.19062 19.9562 2.89388 20.175 2.67508C20.3938 2.45629 20.6905 2.33337 20.9999 2.33337C21.3093 2.33337 21.6061 2.45629 21.8249 2.67508C22.0437 2.89388 22.1666 3.19062 22.1666 3.50004V22.1667C22.1666 22.4761 22.0437 22.7729 21.8249 22.9917C21.6061 23.2105 21.3093 23.3334 20.9999 23.3334Z"
                                fill="#707070" />
                            <path
                                d="M20.9998 25.6667C20.8463 25.6676 20.6941 25.6382 20.5519 25.5801C20.4098 25.5221 20.2805 25.4365 20.1715 25.3284L16.6715 21.8284C16.4518 21.6087 16.3284 21.3107 16.3284 21.0001C16.3284 20.6894 16.4518 20.3914 16.6715 20.1717C16.8912 19.952 17.1891 19.8286 17.4998 19.8286C17.8105 19.8286 18.1085 19.952 18.3281 20.1717L20.9998 22.8551L23.6715 20.1717C23.8912 19.952 24.1891 19.8286 24.4998 19.8286C24.8105 19.8286 25.1085 19.952 25.3281 20.1717C25.5478 20.3914 25.6712 20.6894 25.6712 21.0001C25.6712 21.3107 25.5478 21.6087 25.3281 21.8284L21.8281 25.3284C21.7191 25.4365 21.5898 25.5221 21.4477 25.5801C21.3056 25.6382 21.1533 25.6676 20.9998 25.6667Z"
                                fill="#707070" />
                            <path
                                d="M31.2496 4.66663C31.559 4.66663 31.8558 4.78954 32.0746 5.00833C32.2933 5.22713 32.4163 5.52387 32.4163 5.83329L32.4163 24.5C32.4163 24.8094 32.2933 25.1061 32.0746 25.3249C31.8558 25.5437 31.559 25.6666 31.2496 25.6666C30.9402 25.6666 30.6434 25.5437 30.4246 25.3249C30.2058 25.1061 30.0829 24.8094 30.0829 24.5L30.0829 5.83329C30.0829 5.52387 30.2058 5.22713 30.4246 5.00833C30.6434 4.78954 30.9402 4.66663 31.2496 4.66663Z"
                                fill="#707070" />
                            <path
                                d="M31.2497 2.3334C31.4032 2.33251 31.5555 2.36194 31.6976 2.42C31.8397 2.47806 31.969 2.56361 32.078 2.67174L35.578 6.17174C35.7977 6.39142 35.9211 6.68938 35.9211 7.00007C35.9211 7.31075 35.7977 7.60871 35.578 7.8284C35.3583 8.04809 35.0604 8.17151 34.7497 8.17151C34.439 8.17151 34.1411 8.04809 33.9214 7.8284L31.2497 5.14507L28.578 7.8284C28.3583 8.04809 28.0604 8.17151 27.7497 8.17151C27.439 8.17151 27.1411 8.04809 26.9214 7.8284C26.7017 7.60871 26.5783 7.31076 26.5783 7.00007C26.5783 6.68938 26.7017 6.39143 26.9214 6.17174L30.4214 2.67174C30.5304 2.56361 30.6597 2.47806 30.8018 2.42C30.944 2.36194 31.0962 2.33251 31.2497 2.3334Z"
                                fill="#707070" />
                        </svg>
                        </th>
                   
                        <th [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
                            {{'grades-classes.list-view.grade-name' |translate }}
                        </th>
    
                        <th [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
                            {{'grades-classes.list-view.no-of-classes' |translate }}
                        </th>
                        <th [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
                            {{'table-view.edit' |translate }}
                        </th>
                    </tr>
                </thead>
                <tbody cdkDropList
                [cdkDropListData]="dataArray"
                class=""
                (cdkDropListDropped)="dropGrade($event)">

                <tr [ngStyle]="{'cursor': !fieldsReadOnly ? 'move' :'auto'}"  *ngFor="let grade of dataArray"
                cdkDrag
                [cdkDragDisabled]="fieldsReadOnly">
                <div class="drag-placeholder" *cdkDragPlaceholder></div>
                <div class="drag-perview" *cdkDragPreview>
                    <svg style="margin-inline-end: 1rem;" *ngIf="!fieldsReadOnly" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M0 5.90625H20V7.21875H0V5.90625Z" fill="#797979"/>
                   <path d="M0 9.84375H20V11.1562H0V9.84375Z" fill="#797979"/>
                   <path d="M0 13.7812H20V15.0938H0V13.7812Z" fill="#797979"/>
                   </svg>
                   {{ grade.name }}
                </div>
                <td >
                    <svg *ngIf="!fieldsReadOnly" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 5.90625H20V7.21875H0V5.90625Z" fill="#797979"/>
                        <path d="M0 9.84375H20V11.1562H0V9.84375Z" fill="#797979"/>
                        <path d="M0 13.7812H20V15.0938H0V13.7812Z" fill="#797979"/>
                        </svg>
                </td>
                <td>
                    {{ grade.name }}
                </td>
                <td>
                    {{grade.noOfClasses}}
                </td>
                <td style="cursor: pointer !important;" >
                    <svg  class="editIcon"  (click)="editListViewGrade($event,grade)" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Group" x="0px" y="0px"
                    viewBox="0 0 16 14" style="enable-background:new 0 0 16 14;" xml:space="preserve">
                    <style type="text/css">
                        .st0 {
                            fill: #707070;
                        }
                    </style>
                    <g>
                        <path class="st0"
                            d="M15.4,13H0.6C0.3,13,0,13.2,0,13.5C0,13.8,0.3,14,0.6,14h14.9c0.3,0,0.5-0.2,0.6-0.5C16,13.2,15.7,13,15.4,13z   " />
                        <path class="st0"
                            d="M0.5,11.7l2.4,0c0.1,0,0.3-0.1,0.4-0.1l8.2-8.2c0.2-0.2,0.2-0.5,0-0.7L9.1,0.1C8.9,0,8.6,0,8.4,0.1L6.8,1.8   L0.2,8.4C0.1,8.5,0,8.6,0,8.7l0,2.4c0,0.1,0.1,0.3,0.1,0.4C0.2,11.6,0.4,11.7,0.5,11.7z M8.8,1.2l1.7,1.7L9.5,3.8L7.8,2.2L8.8,1.2z    M1,9l6.1-6.1l1.7,1.7l-6.1,6.1l-1.7,0L1,9z" />
                    </g>
                </svg>
                </td>

                </tr>

                </tbody>
            </table>
         
            <div class="btn-container" *ngIf="saveSortFlag" >
                <button (click)="saveGradesSort()" class="btn btn-primary save-btn"> {{'grades-classes.add-grade-modal.save' | translate}} </button>
            </div>
        </div>

    </div>
    <div *ngIf="fullGrades.length === 0 && !loading">
        <div class="no-grades">
            <label>{{'grades-classes.no-grades' | translate}}</label>
            <button (click)="addGrade()" class="btn btn-primary">{{'grades-classes.add-grade' | translate}}</button>
        </div>
    </div>
</div>

<div *ngIf="initalizeNoResultFlag() && !loading">
    <p [ngStyle]="currLang=='ar'?{'left': '65%'} : {'left': '35%'}"  style="color: #6c757d; font-size: .875rem;" class="text-muted"><strong>{{currLang=== 'en' ? 'No Results Found' : 'لا توجد بيانات'}}</strong></p>
</div>
<app-add-grade (gradesScrollPosition)="scrollToGradePosition($event)"></app-add-grade>
<app-class-students-teachers-list></app-class-students-teachers-list>
<app-class-reorder-modal></app-class-reorder-modal>
